import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity, View, Platform } from 'react-native';
import { JDText } from '@jdreact/jdreact-core-lib';
import st from './style/index';
const isWeb = Platform.OS === 'web';

import Button from '../button';
export default class Alert extends PureComponent {
    render() {
        const {
            title,
            content,
            show,
            overlayClickable,
            confirmText,
            cancelText,
            isShowCancel,
            isShowButton,
            alertStyle
        } = this.props;

        return (show &&
        <View style={[st.container]} className={'ltfe-alert'}>
            <View style={[st.modalContainer] } className={'add-alert'}>
                {/* 遮罩层 */}
                {overlayClickable
                    ? <TouchableOpacity style={st.mask} onPress={this._onCancel} />
                    : <View style={st.mask} />}

                {/* 弹框 */}
              <View style={[st.dialogInner, alertStyle]}>
                <View style={st.content}>
                  {/* 标题 */}
                  {!!title && <JDText style={[st.content_color, st.title]}>{title}</JDText>}
                  {
                    typeof content === 'string'
                      ? <JDText style={[st.content_color, st.main]}>{content}</JDText>
                      : content
                  }

                </View>

                {
                  isShowButton && <View style={st.btn_group}>
                    {isShowCancel &&
                      <TouchableOpacity style={[st.btn, st.cancel_btn]} onPress={this._onCancel} >
                        <JDText style={st.cancel_text}>{cancelText}</JDText>
                      </TouchableOpacity>}
                    <Button containerStyle={[st.btn]} contentStyle={[st.wrap, !isShowCancel && st.single]} onPress={this._onConfirm}>
                      <JDText style={st.sure_text}>{confirmText}</JDText>
                    </Button>
                  </View>
                }
              </View>
            </View>
        </View>
        );
    }
    componentDidMount() {
        isWeb && setTimeout(() => {
            // TODO:解决点透问题
            const dom = document.querySelector('.ltfe-alert');
            dom && dom.addEventListener('touchend', function(e) {
                e.preventDefault();
            }, false);
        }, 10);
    }
    _onCancel = () => {
        this.props.onCancel && this.props.onCancel();
    }
    _onConfirm = () => {
        this.props.onConfirm && this.props.onConfirm();
    }
}

Alert.propTypes = {
    title: PropTypes.string, // 标题
    show: PropTypes.bool.isRequired, // 是否展示
    onConfirm: PropTypes.func, // 点击确定的回调方法
    onCancel: PropTypes.func, // 点击取消按钮的回调
    isShowCancel: PropTypes.bool, // 是否显示取消按钮
    cancelText: PropTypes.string, // 取消按钮文案
    confirmText: PropTypes.string, // 确定按钮文案
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]), // 弹框内容
    overlayClickable: PropTypes.bool, // 点击膜层后是否关闭对话框，默认是关闭的
    isShowButton: PropTypes.bool, // 是否显示按钮
    alertStyle: PropTypes.object, // 弹窗外部样式
};

Alert.defaultProps = {
    cancelText: '取消',
    confirmText: '确定',
    isShowCancel: false
};
